import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import AddBlogDetailsPage from '../../../components/siteadmin/AddBlogDetails/AddBlogDetails';

import s from './AddBlogDetails.css';

const AddBlogDetails = (props) => {

    const { data: { loading }, title } = props;

    return (
        <AddBlogDetailsPage
            title={title}
        />
    );
}

AddBlogDetails.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
        loading: PropTypes.bool,
        getBlogParentPage: PropTypes.any,
    })
};

AddBlogDetails.defaultProps = {
    data: {
        loading: true
    }
};

export default compose(
    withStyles(s),
)(AddBlogDetails);